module.exports = __webpack_public_path__ + "static/media/hygiena.aa55e35b.jpg";